import { StyleSheet, Dimensions } from 'react-native';
import theme from '@/constants/colors';
import { Typography } from '@/constants/typography';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: theme.backgroundPrimary,
    },
    headerButtons: {
        position: 'absolute',
        left: 0,
        right: 0,
        zIndex: 100,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 16,
    },
    headerButton: {
        width: 44,
        height: 44,
        borderRadius: 22,
        backgroundColor: theme.backgroundPrimary,
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.25,
        shadowRadius: 4,
        elevation: 4,
    },
    headerRightButtons: {
        flexDirection: 'row',
        gap: 12,
    },
    headerBarScrolled: {
        backgroundColor: theme.backgroundPrimary,
        borderBottomWidth: 1,
        borderBottomColor: theme.borderSubtle,
        paddingBottom: 6,
    },
    scrollContainer: {
        flex: 1,
    },
    scrollContent: {
        paddingBottom: 160,
    },
    bottomFooter: {
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: theme.backgroundPrimary,
        paddingHorizontal: 16,
        paddingTop: 12,
        borderTopWidth: 1,
        borderTopColor: theme.borderSubtle,
        zIndex: 50,
    },
    loadingContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.backgroundPrimary,
    },
    loadingText: {
        marginTop: 16,
        ...Typography.body(theme.accentPrimary),
    },
    heroSection: {
        position: 'relative',
    },
    heroImageContainer: {
        width: '100%',
        height: 320,
        position: 'relative',
        borderBottomLeftRadius: 24,
        borderBottomRightRadius: 24,
        overflow: 'hidden',
    },
    heroImage: {
        width: '100%',
        height: '100%',
        backgroundColor: theme.borderSubtle,
    },
    heroImageScroll: {
        flexDirection: 'row',
        alignItems: 'stretch',
    },
    paginationDots: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 5,
        marginTop: 12,
    },
    heroSwipeHint: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderRadius: 999,
        backgroundColor: theme.accentPrimary,
    },
    heroSwipeHintText: {
        ...Typography.caption(theme.backgroundPrimary),
        textTransform: 'uppercase',
        letterSpacing: 0.6,
    },
    dot: {
        width: 5,
        height: 5,
        borderRadius: 2.5,
        backgroundColor: theme.backgroundSecondaryVarient,
    },
    dotActive: {
        width: 5,
        height: 5,
        borderRadius: 2.5,
        backgroundColor: theme.accentPrimary,
    },
    changePhotoFab: {
        position: 'absolute',
        bottom: 20,
        right: 18,
        width: 56,
        height: 56,
        borderRadius: 28,
        backgroundColor: theme.backgroundPrimary,
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.3,
        shadowRadius: 8,
        elevation: 6,
    },

    collapseButton: {
        position: 'absolute',
        bottom: 12,
        left: 0,
        right: 0,
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 20,
    },

    addPhotoContainer: {
        width: '100%',
        height: 280,
        backgroundColor: theme.accentPrimary,
        justifyContent: 'center',
        alignItems: 'center',
        paddingHorizontal: 32,
    },
    addPhotoIcon: {
        width: 72,
        height: 72,
        borderRadius: 36,
        backgroundColor: theme.backgroundPrimary,
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 16,
    },
    addPhotoText: {
        ...Typography.h2(theme.textPrimary),
        marginBottom: 4,
    },
    addPhotoSubtext: {
        ...Typography.caption(theme.backgroundSecondary),
    },
    contentWrapper: {
        backgroundColor: theme.backgroundPrimary,
        marginTop: -24,
        zIndex: 10,
        overflow: 'hidden',
    },
    content: {
        padding: 24,
        paddingTop: 28,
    },
    titleSection: {
        marginBottom: 20,
    },
    dateRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        marginBottom: 8,
    },
    dateText: {
        ...Typography.body(theme.textMuted),
    },
    titleRow: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 12,
        marginBottom: 8,
    },
    title: {
        flex: 1,
        ...Typography.h1(theme.accentPrimary),
        lineHeight: 40,
    },
    authorRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        marginTop: 8,
        marginBottom: 16,
    },
    avatar: {
        width: 18,
        height: 18,
        borderRadius: 9,
        backgroundColor: theme.backgroundSecondary,
    },
    avatarText: {
        ...Typography.label(theme.accentPrimary),
    },
    authorName: {
        ...Typography.body(theme.textPrimary),
    },
    editIconButton: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: theme.accentPrimary,
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 4,
    },
    nameEditContainer: {
        marginBottom: 8,
    },
    nameInput: {
        ...Typography.h2(theme.textPrimary),
        backgroundColor: theme.textPrimary,
        borderWidth: 2,
        borderColor: theme.backgroundPrimary,
        borderRadius: 12,
        padding: 12,
        marginBottom: 12,
    },
    nameInputInDetails: {
        ...Typography.body(theme.textPrimary),
        backgroundColor: theme.backgroundPrimary,
        borderWidth: 1,
        borderColor: theme.accentPrimary,
        borderRadius: 12,
        padding: 16,
    },
    editButtons: {
        flexDirection: 'row',
        gap: 8,
    },
    iconButton: {
        width: 44,
        height: 44,
        borderRadius: 22,
        justifyContent: 'center',
        alignItems: 'center',
    },
    saveIconButton: {
        backgroundColor: theme.backgroundPrimary,
    },
    cancelIconButton: {
        backgroundColor: theme.accentPrimary,
    },
    locationRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
        marginBottom: 16,
    },
    location: {
        ...Typography.body(theme.textMuted),
    },
    ratingRow: {
        flexDirection: 'row',
        gap: 4,
    },
    reviewCard: {
        marginBottom: 24,
    },
    reviewText: {
        ...Typography.body(theme.textPrimary),
        lineHeight: 24,
    },
    statsSection: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 12,
        marginBottom: 24,
    },
    statCard: {
        width: '48%', // Approx half minus gap
        borderRadius: 14,
        paddingVertical: 10,
        paddingHorizontal: 16,
        alignItems: 'flex-start',
        borderWidth: 1,
        borderColor: theme.borderSubtle,
    },
    statLabel: {
        ...Typography.caption(theme.textMuted),
        textTransform: 'uppercase',
        marginBottom: 8,
    },
    statValue: {
        ...Typography.h3(theme.accentPrimary),
    },
    tagsSection: {
        marginBottom: 20,
    },
    sectionHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        marginBottom: 16,
    },
    sectionTitle: {
        ...Typography.h2(theme.textPrimary),
    },
    tagsGrid: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
    },
    tagChip: {
        paddingHorizontal: 24,
        paddingVertical: 12,
        borderRadius: 24,
        borderWidth: 1,
        borderColor: theme.borderSubtle,
        justifyContent: 'center',
        alignItems: 'center',
    },
    tagText: {
        ...Typography.label(theme.textMuted),
    },
    editDetailsButton: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        backgroundColor: theme.textPrimary,
        borderRadius: 12,
        paddingVertical: 14,
        paddingHorizontal: 20,
        marginBottom: 20,
        borderWidth: 2,
        borderColor: theme.backgroundPrimary,
    },
    editDetailsText: {
        ...Typography.label(theme.backgroundPrimary),
    },
    editSection: {
        backgroundColor: theme.backgroundSecondary,
        borderRadius: 16,
        padding: 20,
        marginBottom: 20,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
        elevation: 2,
    },
    editSectionTitle: {
        ...Typography.h2(theme.textPrimary),
        marginBottom: 12,
    },
    ratingStars: {
        flexDirection: 'row',
        gap: 8,
    },
    starButton: {
        padding: 4,
    },
    reviewInput: {
        backgroundColor: theme.backgroundPrimary,
        borderWidth: 1,
        borderColor: theme.accentPrimary,
        borderRadius: 12,
        padding: 16,
        ...Typography.body(theme.textPrimary),
        minHeight: 120,
    },
    difficultyOptions: {
        flexDirection: 'row',
        gap: 8,
    },
    difficultyChip: {
        flex: 1,
        paddingVertical: 12,
        paddingHorizontal: 16,
        borderRadius: 12,
        backgroundColor: theme.backgroundPrimary,
        borderWidth: 2,
        borderColor: theme.accentPrimary,
        alignItems: 'center',
    },
    difficultyChipSelected: {
        backgroundColor: theme.backgroundPrimary,
        borderColor: theme.backgroundPrimary,
    },
    difficultyChipText: {
        ...Typography.label(theme.backgroundSecondary),
    },
    difficultyChipTextSelected: {
        color: theme.textPrimary,
    },
    editTagChip: {
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 20,
        backgroundColor: theme.backgroundPrimary,
        borderWidth: 1.5,
        borderColor: theme.accentPrimary,
    },
    editTagChipSelected: {
        backgroundColor: theme.backgroundPrimary,
        borderColor: theme.backgroundPrimary,
    },
    editTagChipText: {
        ...Typography.label(theme.backgroundSecondary),
    },
    editTagChipTextSelected: {
        color: theme.textPrimary,
    },
    editActionButtons: {
        flexDirection: 'row',
        gap: 12,
        marginTop: 24,
    },
    actionButton: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        paddingVertical: 14,
        borderRadius: 12,
    },
    cancelActionButton: {
        backgroundColor: theme.backgroundPrimary,
        borderWidth: 2,
        borderColor: theme.accentPrimary,
    },
    cancelActionText: {
        ...Typography.label(theme.textPrimary),
    },
    saveActionButton: {
        backgroundColor: theme.backgroundPrimary,
    },
    saveActionText: {
        ...Typography.label(theme.textPrimary),
    },
    mapSection: {
        marginBottom: 20,
    },
    mapContainer: {
        height: 260,
        borderRadius: 16,
        overflow: 'hidden',
        marginBottom: 16,
        borderWidth: 1,
        borderColor: theme.borderSubtle,
    },
    map: {
        width: '100%',
        height: '100%',
    },
    buttonsRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
    },
    webMapPlaceholder: {
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: theme.accentPrimary,
    },
    webMapText: {
        marginTop: 12,
        ...Typography.caption(theme.backgroundSecondary),
    },
    directionsButton: {
        width: 56,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.backgroundSecondary,
        borderRadius: 12,
        paddingVertical: 16,
        paddingHorizontal: 16,
        shadowColor: theme.backgroundPrimary,
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.3,
        shadowRadius: 8,
        elevation: 4,
    },
    directionsButtonText: {
        ...Typography.label(theme.textPrimary),
    },
    detailsSection: {
        backgroundColor: theme.backgroundSecondary,
        borderRadius: 16,
        padding: 20,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
        elevation: 2,
    },
    detailsTitle: {
        ...Typography.h2(theme.backgroundPrimary),
        marginBottom: 16,
    },
    detailRow: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        paddingVertical: 12,
        borderBottomWidth: 1,
        borderBottomColor: theme.backgroundPrimary,
    },
    detailIcon: {
        width: 36,
        height: 36,
        borderRadius: 18,
        backgroundColor: theme.accentPrimary,
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: 12,
    },
    detailContent: {
        flex: 1,
    },
    detailLabel: {
        ...Typography.caption(theme.backgroundSecondary),
        marginBottom: 2,
    },
    detailValue: {
        ...Typography.body(theme.backgroundPrimary),
    },
    startButton: {
        width: '100%',
        backgroundColor: theme.accentPrimary,
        borderRadius: 28,
        paddingVertical: 18,
        alignItems: 'center',
        justifyContent: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 6 },
        shadowOpacity: 0.16,
        shadowRadius: 12,
        elevation: 6,
        marginBottom: 24,
    },
    startButtonInline: {
        flex: 1,
        backgroundColor: theme.accentPrimary,
        borderRadius: 16,
        paddingVertical: 14,
        alignItems: 'center',
        justifyContent: 'center',
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 6 },
        shadowOpacity: 0.16,
        shadowRadius: 12,
        elevation: 6
    },
    startButtonText: {
        ...Typography.h2(theme.backgroundPrimary),
    },
    reviewsSection: {
        marginBottom: 24,
    },
    reviewsRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    reviewsTitle: {
        ...Typography.caption(theme.textPrimary),
        marginBottom: 12,
    },
    reviewStars: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
    },
    /* Map modal / fullscreen map styles */
    mapModal: {
        flex: 1,
        backgroundColor: theme.backgroundPrimary,
    },
    mapModalHeader: {
        height: 64,
        paddingHorizontal: 16,
        justifyContent: 'center',
    },
    mapModalClose: {
        width: 44,
        height: 44,
        borderRadius: 22,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'transparent',
    },
    fullscreenMapContainer: {
        flex: 1,
        backgroundColor: theme.borderSubtle,
    },
    fullscreenMap: {
        width: '100%',
        height: '100%',
    },
    mapModalFooter: {
        padding: 16,
        backgroundColor: theme.backgroundPrimary,
    },
    beginNavButton: {
        backgroundColor: theme.accentPrimary,
        borderRadius: 16,
        paddingVertical: 14,
        alignItems: 'center',
    },
    beginNavText: {
        ...Typography.h2(theme.backgroundPrimary),
    },
});

export default styles;
